export const helpers = {
	humanize: {
		paymentMethod: {
			anticipated: "Anticipado",
			bleedings: "Sangría",
			deliveryOnline: "Delivery Online",
			ame: "Ame",
			uber: "Uber",
			ifood: "Ifood",
			app: "Aplicación",
			cash: "Efectivo",
			automaticDebit: "Débito Automático",
			boleto: "Boleto",
			bankTransfer: "Transferencia bancaria",
			promissory: "Pagaré",
			check: "Cheque",
			creditCard: "Tarjeta de crédito",
			zigPosCredit: "Zig pos crédito",
			zigCredit: "Zig crédito",
			debitCard: "Tarjeta de débito",
			zigPosDebit: "Zig pos débito",
			zigDebit: "Zig débito",
			voucher: "Voucher",
			dashboard: "Dashboard",
			postEvent: "Después del evento",
			rappi: "Rappi",
			consumptionFromBar: "Consumo anticipado",
			pix: "Pix",
			bonus: "Bonus",
			other: "Otro",
			zigPosCreditInInstallments: "Crédito en cuotas",
			integratedFoodVoucher: "Vale de comida",
		},
	},
	string: {
		grams: "Gramos",
		kilogram: "Kilogramos",
		liter: "Litros",
		milliliter: "Mililitros",
		unit: "Unidades",
		lowercase: {
			grams: "gramos",
			kilogram: "kilogramos",
			liter: "litros",
			milliliter: "mililitros",
			unit: "unidades",
		},
	},
};
